import { useMemo } from 'react';

import { useToken } from '../auth/use-token.js';

import { createApiClient, type ApiClient } from './client.js';

/**
 * Returns a memoized `ApiClient`. The token-fetching closure is recreated
 * whenever MSAL accounts change; we re-build the client with it so every
 * request picks up the latest token.
 */
export function useApi(): ApiClient {
  const getToken = useToken();
  return useMemo(() => createApiClient(getToken), [getToken]);
}
